export const COLORS = {
  groupBlue: '#3582CE',
  lightGrey: '#F5F5F5',
  darkGrey: '#4E5557',
  mainLightBlue: '#52CFF4',
  grey: '#959595',
  white: '#FFFFFF',
  campoBlue: '#52CFF4',
  motoOrange: '#FCBB41',
  agroGreen: '#BAC628',
  errorRed: '#D90A16',
  successGreen: '#7FC324',
  progressOrange: '#FF7031',
  yellow: '#FFC136',
  darkBlue: '#2D6CAA',
  lightYellow: '#FDC136',
  lightBlue: '#74BAFF'
}

export const SPACE = 4
